import { Injectable } from '@angular/core';
import { ProductConfigDataRequest } from './product-config-details.model';
import { ProductConfigDetailsAdapter } from './product-config-details.adapter';

@Injectable({
  providedIn: 'root',
})
export class ProductConfigDetailsService {
  constructor(private productConfigDetailsAdapter: ProductConfigDetailsAdapter) {}

  getProductConfigDetails(config: ProductConfigDataRequest) {
    return this.productConfigDetailsAdapter.getProductConfigDetails(config);
  }
}
